import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FileExtensionPreview, getFilename } from "@air/component-file-extension-preview";
export const DNDFileGalleryCardDragPreview = (param)=>{
    let { file } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex size-full flex-col justify-between rounded-4 bg-white p-3",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex size-8 shrink-0 items-center justify-center rounded-4 bg-pigeon-100",
                children: /*#__PURE__*/ _jsx(FileExtensionPreview, {
                    ext: file.ext
                })
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "pointer-events-auto truncate font-medium",
                children: getFilename(file)
            })
        ]
    });
};
